var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "header",
    { staticClass: "entry-layout-header" },
    [
      _c("span", { staticClass: "entry-layout-header-logo" }, [
        _c("img", { style: _vm.logoStyle, attrs: { src: _vm.logo } }),
      ]),
      _c("div", { staticClass: "entry-layout-menus" }, [_vm._v("启航ERP")]),
      _c("AvatarDropdown"),
      !_vm.isYST_user
        ? _c("ServiceEnter", { attrs: { getQueryList: _vm.getQueryList } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }